<template>
    <div>
        <div class="modal fade" id="mdDetalhesTitulos" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-info-circle"></i> Informações do título</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" id="conteudodet" style="display: none;">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Nº Título:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.codtit" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label>Cliente:</label>
                                <input type="text" class="form-control form-control-sm" v-bind:value="dnomecliente" data-bv-group=".group" maxlength="50" readonly="true"/>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Cod.Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.codauxiliar" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Emissão:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.dtemitit" data-bv-group=".group" readonly="true">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Vencimento:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.dtventit" data-bv-group=".group" readonly="true">
                                <span v-if="parseInt(dtitulo.atraso) > 0" id="span-atraso" class="badge badge-pill badge-danger" title="Dias em atraso">{{ dtitulo.atraso }}</span>                                
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Valor:</label>
                                <money class="form-control form-control-sm" v-bind="money" v-model="dtitulo.vlresta"
                                    data-bv-group=".group" style="text-align:right; background: #0a8e68; color: white; font-weight: bold;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label>Filial:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.fantasia" data-bv-group=".group" readonly="true">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label>Cobrança:</label>
                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.desccob" data-bv-group=".group" readonly="true">
                            </div>
                            <div v-show="situacao !=='B'" class="col-sm-12 col-md-3 col-lg-3">
                                <label>Situação:</label>
                                <input v-if="parseInt(dtitulo.inativo) === 0" type="text" class="form-control form-control-sm" value="ATIVO" style="text-transform: uppercase; text-align:center; font-weight: bold;" data-bv-group=".group" readonly="true">
                                <input v-else type="text" class="form-control form-control-sm" value="INATIVO" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">                                
                            </div>
                            <div class="col-sm-12" v-show="parseInt(dtitulo.tipocobranca) === 1">
                                <div class="card" id="pnlchequedet" style="margin-top: 15px; margin-bottom: 10px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;"><span>DADOS DO CHEQUE</span></div>
                                    <div class="card-body" style="padding-bottom: 15px;">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Nº Cheque:</label>
                                                <input type="text" class="form-control form-control-sm" 
                                                    v-model="dtitulo.numerocheque" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <label>Banco:</label>
                                                <input type="text" class="form-control form-control-sm" 
                                                    v-model="dtitulo.descbanco" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Agência:</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    v-model="dtitulo.agencia" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Conta:</label>
                                                <input type="text" class="form-control form-control-sm"
													v-model="dtitulo.conta"
                                                    maxlength="20" style="text-transform: uppercase;" 
													data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label>Praça:</label>
                                                <input type="text" class="form-control form-control-sm" v-model="dtitulo.praca"
                                                    maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label>Emitente:</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    v-model="dtitulo.emitente" maxlength="50"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Cnpj/Cpf:</label>
                                                <input type="text" v-mask="['##.###.###/####-##', '###.###.###-##']" class="form-control form-control-sm"
                                                    v-model="dtitulo.cnpjcpf" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <label>Situação do cheque:</label>
                                                <input type="text" class="form-control form-control-sm" 
                                                    v-model="dtitulo.descsitch" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="situacao ==='B'">
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <label>Vendedor:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.nomevendedor" data-bv-group=".group" readonly="true">
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <label>Cobrador:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.nomecobrador" data-bv-group=".group" readonly="true">
                                </div>                                
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label>Juros(Pg):</label>
                                    <money class="form-control form-control-sm" v-bind="money" v-model="dtitulo.vljuros"
                                    data-bv-group=".group" style="text-align:right;" readonly="true">
                                </money>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label>Multa(Pg):</label>
                                    <money class="form-control form-control-sm" v-bind="money" v-model="dtitulo.vlmulta"
                                    data-bv-group=".group" style="text-align:right;" readonly="true">
                                </money>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label>Pago Tit:</label>
                                    <money class="form-control form-control-sm" v-bind="money" v-model="dtitulo.vlpagtit"
                                    data-bv-group=".group" style="text-align:right; font-weight: bold;" readonly="true">
                                    </money>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <label>Total Pago:</label>
                                    <money class="form-control form-control-sm" v-bind="money" v-bind:value="parseFloat(dtitulo.vlpagtit + dtitulo.vljuros + dtitulo.vlmulta)"
                                    data-bv-group=".group" style="text-align:right; background: #0acf97; color: white; font-weight: bold;" readonly="true">
                                    </money>
                                </div>                                                                                                
                            </template>
                            <template v-else>    
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label>Vendedor:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.nomevendedor" data-bv-group=".group" readonly="true">
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label>Cobrador:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.nomecobrador" data-bv-group=".group" readonly="true">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label>Juros:</label>
                                    <input v-if="parseInt(dtitulo.tpcalcjuros) === 0" type="text" v-bind:value="dtitulo.fatjuros+'%'" class="form-control form-control-sm" style="text-align:right; text-transform: uppercase;" data-bv-group=".group" readonly="true" title="Tipo de cálculo do juros p/ dia">
                                    <input v-else type="text" v-bind:value="'R$ '+dtitulo.fatjuros" class="form-control form-control-sm" style="text-align:right; text-transform: uppercase;" data-bv-group=".group" readonly="true" title="Tipo de cálculo do juros p/ dia">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label>Multa:</label>
                                    <input v-if="parseInt(dtitulo.tpcalcmulta) === 0" type="text" v-bind:value="dtitulo.fatmulta+'%'" class="form-control form-control-sm" style="text-align:right; text-transform: uppercase;" data-bv-group=".group" readonly="true" title="Tipo de cálculo da multa">
                                    <input v-else type="text" v-bind:value="'R$ '+dtitulo.fatmulta" class="form-control form-control-sm" style="text-align:right; text-transform: uppercase;" data-bv-group=".group" readonly="true" title="Tipo de cálculo da multa">
                                </div>
                            </template>

                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label>Conta:</label>
                                <input v-if="parseInt(dtitulo.idconta) > 0" type="text" class="form-control form-control-sm" v-bind:value="dtitulo.idconta +' - '+ dtitulo.descconta" data-bv-group=".group" maxlength="60" readonly="true"/>
                                <input v-else type="text" class="form-control form-control-sm" v-bind:value="''" data-bv-group=".group" maxlength="60" readonly="true"/>
                            </div>                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label>Nosso número:</label>
                                <input v-if="parseInt(dtitulo.nossonumero) > 0" type="text" class="form-control form-control-sm text-right" v-bind:value="mtdformatarzeros(dtitulo.nossonumero, 8)" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                <input v-else type="text" class="form-control form-control-sm" v-bind:value="''" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                            </div>


                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label>Observações:</label>
                                <textarea class="form-control center" rows="2" id="txtobs" v-model="dtitulo.obstit"
                                    style="text-transform: uppercase;"
                                    readonly="true">
                                </textarea>
                            </div>
                            <template v-if="situacao ==='B'">
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <label>Informações do sistema:</label>
                                    <input type="text" class="form-control form-control-sm" v-bind:value="dtitulo.obstitsis + ' por '+dtitulo.nomeusu" data-bv-group=".group" readonly="true">
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label>Filial Baixa:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.fantasiabaixa" data-bv-group=".group" readonly="true">
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <label>Informações do sistema:</label>
                                    <input type="text" class="form-control form-control-sm" v-model="dtitulo.obstitsis" data-bv-group=".group" readonly="true">
                                </div>                                
                            </template>
                            <div v-if="situacao ==='B'" class="col-sm-12 col-md-12 col-lg-12">
                                <label>Observações da baixa:</label>
                                <textarea class="form-control center" rows="2" id="txtobs" v-model="dtitulo.obsbaixa"
                                    style="text-transform: uppercase;"
                                    readonly="true">
                                </textarea>
                            </div>                                                                  
                            <div class="col-sm-12" v-show="dpagos.length > 0">
                                <div class="card" id="pnlpagos" style="margin-top: 15px; margin-bottom: 10px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;"><span>PAGAMENTOS DO TÍTULO</span></div>
                                    <div class="card-body" style="padding: 10px;">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistapagamentos" class="table table-bordered table-sm table-hover">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th>Dt. Pagamento:</th>
                                                            <th>Filial/Baixa:</th>
                                                            <th>Usuário/Baixa:</th>
                                                            <th width="100px">Juros:</th>
                                                            <th width="100px">Multa:</th>
                                                            <th width="100px">Total pago:</th>                                                            
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlistapagamentos">
                                                            <tr v-for="(titulo, index) in dpagos" v-bind:key="index">
                                                                <td>{{ titulo.dtpagtit }}</td>
                                                                <td>{{ titulo.fantasiabaixa }}</td>
                                                                <td>{{ titulo.nomeusu }}</td>
                                                                <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(titulo.vljuros), 2) }}</td>
                                                                <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2) }}</td>
                                                                <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(titulo.vlpagtit) + parseFloat(titulo.vljuros) + parseFloat(titulo.vlmulta), 2) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                        <span style="color: #666666; font-weight: bold;">Total pago</span>
                                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(dtotalpago), 2)}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-sign-out"></i> Fechar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpdetalhestituloreceber',
    props:['idcliente',
           'codtit',
           'situacao'
          ],
    data: function() {
        return {
            dtitulo         : [],
            dpagos          : [],
            dtotalpago      : 0,
            dnomecliente    : '',
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },  
        mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
		},              
        mtddefinicoes(){   
            let vself       = this;
            $('#mdDetalhesTitulos').on('hidden.bs.modal', function (e) {
                $('#conteudodet').hide();
            });         
            $('#mdDetalhesTitulos').on('show.bs.modal', function (e) {
                vself.dtitulo       = [];
                vself.dpagos        = [];
                vself.dnomecliente  = '';
            });				
            $('#mdDetalhesTitulos').on('shown.bs.modal', function (e) {
              let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'detalhestitulo'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'situacao',         valor : vself.situacao},
                    {parametro: 'idcliente',        valor : vself.idcliente},
                    {parametro: 'codtit',           valor : vself.codtit}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.dtitulo       = response.data.titulo;
                    vself.dpagos        = response.data.pagos;
                    vself.dtotalpago    = response.data.totalpago;
                    vself.dnomecliente  = vself.dtitulo.idcliente+' - '+vself.dtitulo.nomecliente;
                    $('#conteudodet').fadeIn(500);
                }).catch(function (response) {
                    loader.hide();
                });                
                //aqui podemos setar o foco                
            });
        }
    },
    mounted: function() {
        this.mtddefinicoes();
    },    
    computed:{ 
    },
    watch: {

    }
}
</script>
<style>
    #span-atraso{
        position: relative;
        float: right;
        top: -22px;
        left: -5px;
        margin-bottom: -15px;
    }
</style>